<template>
    <div class="cashout-success" v-if="certifyStatus == 1">
        <div v-if="success">
            <div class="icon-cash-success"></div>
            <p class="words">提现成功</p>
            <p class="tips">预计一个工作日内到账，请耐心等待~</p>
        </div>
        <div v-else>
            <div class="icon-cash-fail"></div>
            <p class="words">提现失败</p>
            <p class="tips">请联系客服处理</p>
        </div>
        <el-button class="btn-kf" @click="gotofk">联系客服</el-button>
        <el-button type="primary" class="btn" @click="goBack">返回钱包</el-button>
    </div>
</template>
<script>
    export default {
        name: 'CashOut',
        data() {
            return {
                cashoutParams: {},
                certifyStatus: 0,
                success: false
            }
        },
        computed: {
            userData() {
                return this.$store.getters.state.userData || {};
            },
        },
        mounted() {
            let params = localStorage.getItem('cashout_params');
            if(params) {
                this.cashoutParams = JSON.parse(params)
                this.certifyquery()
            }
        },
        methods: {
            goBack() {
                this.$router.push({
                    name: 'user.wallet',
                });
            },
            certifyquery() {                
                this.$Ajax("user-info/certify-query", {
                    certifyId: this.cashoutParams.certifyId,
                }).then(rs => {
                    this.certifyStatus = 1
                    if (rs.code == 200) {
                        this.success = true
                        this.$toast({
                            message: '身份验证成功',
                            duration: "2000",
                        });
                        this.certifySubmit()
                    }else{
                        this.success = false
                        this.$toast({
                            message: '身份验证失败',
                            duration: "2000",
                        });
                    }
                })
            },
            certifySubmit() {
                this.$Ajax("wallet/cash", {
                    account: this.cashoutParams.account,
                    name: this.cashoutParams.name,
                    amount: this.cashoutParams.amount,
                    alipay_img: this.cashoutParams.third_img,
                }).then(rs => {
                    if (rs.code == 200) {
                        this.success = true
                    }else {
                        this.$toast({
                            message: rs.msg,
                            duration: "2000",
                        });
                        this.success = false
                    }
                })
            },
            gotofk() {
                window.location.href = 'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_' + this.userData.user_id + '&phone=' + this.userData.username
            }
        },
        beforeRouteLeave(to, from, next) {
            localStorage.removeItem('cashout_params')
            next()
        }
    }
</script>
<style lang="less" scoped>
    .cashout-success {
        padding: 14.2rem 2rem 0;
    }
    .icon-cash-success {
        width: 4.3rem;
        height: 4.3rem;
        background-image: url('../../assets/bx/cashsuccess.png');
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .icon-cash-fail {
        width: 4.3rem;
        height: 4.3rem;
        background-image: url('../../assets/bx/cashfail.png');
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .words {
        font-size: 1.6rem;
        font-weight: 700;
        text-align: center;
        color: #000;
        margin-top: 1.7rem;
        margin-bottom: 1.2rem;
    }
    .tips {
        font-size: 1.2rem;
        text-align: center;
        color: #9e9e9e;
    }
    .el-button {
        margin: 0;
        &:nth-of-type(1) {
            margin-top: 5.5rem;
        }
        &:nth-of-type(2) {
            margin-top: 2rem;
        }
    }
    .btn-kf {
        width: 100%;
        height: 3.7rem;
        border-radius: 10rem;
    }
    .btn {
        width: 100%;
        height: 3.7rem;
        font-size: 1.4rem;
        color: #fff;
        background-color: #ff6600;
        border-radius: 10rem;
    }
</style>
